/* eslint-disable @next/next/no-img-element */

interface props {
  blogDate?: string;
  title?: string;
  textContent?: string;
  imageLink?: string;
  blogLink?: string;
  tag?: string;
  tagBgClasses?: string;
  className?: string;
}

export const BlogsScrollerCard = ({
  blogDate,
  title,
  textContent,
  imageLink,
  tag,
  tagBgClasses,
  blogLink,
  className,
}: props) => {
  return (
    <a href={blogLink} className={`${className}`}>
      <div className="flex  relative">
        <img className="w-[383px] h-[283px]" src={imageLink} alt="" />
        <div className={`absolute ${tagBgClasses}`}>{tag}</div>
      </div>
      <p className="font-openSans font-normal  text-web-body-sm leading-4 text-brand-textLightGrey mt-[35px]">
        {blogDate}
      </p>
      <p className="font-openSans font-normal text-web-subheading leading-6 text-brand-textBlack mt-[18px]">
        {title}
      </p>
      <p className="font-openSans font-normal text-web-body-lg leading-[21px] text-brand-textLightGrey mt-[9px]">
        {textContent}
      </p>
    </a>
  );
};
